<template>
    <div class="wrap type-main">
        <!-- header -->
        <div class="header">
            <div style="max-width: 1000px; margin: 0 auto;">
                <a href="/" style="float: left">
                    <div class="logo">
                        <div style="padding-top: 18px; padding-right: 100px">
                            <span style="color: #fff;">방문예약시스템</span>
                        </div>
                    </div>
                </a>

                <div class="hdmenu" v-if="$route.path != '/'">
                    <div v-if="this.propscomCodeInfo == 'iljinm' || $route.path.indexOf('/ijmt') !== -1">
                        <ul>
                            <li><router-link to="/ijmt/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijmt/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijmt/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijmt/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljinst' || $route.path.indexOf('/ijst') !== -1">
                        <ul>
                            <li><router-link to="/ijst/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijst/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijst/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijst/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljinel' || $route.path.indexOf('/ijel') !== -1">
                        <ul>
                            <li><router-link to="/ijel/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijel/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijel/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijel/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljinhd' || $route.path.indexOf('/ijhd') !== -1">
                        <ul>
                            <li><router-link to="/ijhd/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijhd/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijhd/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijhd/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljindm' || $route.path.indexOf('/ijdm') !== -1">
                        <ul>
                            <li><router-link to="/ijdm/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijdm/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijdm/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijdm/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljinap' || $route.path.indexOf('/ijap') !== -1">
                        <ul>
                            <li><router-link to="/ijap/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijap/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijap/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijap/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljincomposite' || $route.path.indexOf('/ijbh') !== -1">
                        <ul>
                            <li><router-link to="/ijbh/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijbh/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijbh/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijbh/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                    <div v-else-if="this.propscomCodeInfo == 'iljincs' || $route.path.indexOf('/ijcs') !== -1">
                        <ul>
                            <li><router-link to="/ijcs/visitProposal">방문신청</router-link></li>
                            <li><router-link to="/ijcs/visitStatus">진행현황</router-link></li>
                            <li><router-link to="/ijcs/board/notice">공지사항</router-link></li>
                            <li><router-link to="/ijcs/board/faq">FAQ</router-link></li>
                        </ul>
                    </div>
                </div>
                 <div class="lowmenu" v-on:click="showMenu()" v-if="$route.path != '/'"><img src="/img/btn_menu_open.png"/></div>
            </div>
        </div>
        <!-- 창이 줄었을때 메뉴레이어 -->
        <div class="menu_bg">
            <div class="menu" v-if="this.propscomCodeInfo == 'iljinm' || $route.path.indexOf('/ijmt') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijmt/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijmt/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijmt/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijmt/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljinst' || $route.path.indexOf('/ijst') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijst/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijst/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijst/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijst/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljinel' || $route.path.indexOf('/ijel') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijel/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijel/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijel/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijel/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljinhd' || $route.path.indexOf('/ijhd') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijhd/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijhd/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijhd/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijhd/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljindm' || $route.path.indexOf('/ijdm') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijdm/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijdm/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijdm/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijdm/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljinap' || $route.path.indexOf('/ijap') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijap/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijap/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijap/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijap/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljincomposite' || $route.path.indexOf('/ijbh') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijbh/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijbh/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijbh/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijbh/board/faq">FAQ</router-link></div>
            </div>
            <div class="menu" v-else-if="this.propscomCodeInfo == 'iljincs' || $route.path.indexOf('/ijcs') !== -1">
                <div class="closearea" v-on:click="hideMenu()"><img src="/img/close.png"/></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijcs/visitProposal">방문신청</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijcs/visitStatus">진행현황</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijcs/board/notice">공지사항</router-link></div>
                <div class="menu-s" v-on:click="hideMenu()"><router-link to="/ijcs/board/faq">FAQ</router-link></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Navbar',
  props: ['propscomCodeInfo'],
  computed:{
    classObj() {
      return {
        'navbar-item': true,
        'is-hoverable': true,
      }
    },
  },

  data() {
    return {
    };
  },
  created(){
  },
  methods: {
    logout() {
      this.$http
        .get('/logout')
        .then(() => {
          this.$store.commit('logout');
          this.$cookie.delete('loginInfo');
        })
        .catch((e) => {
          console.error(e);
        });
    },

    showMenu(){
        var giMenuDuration = 700;
        $('.menu_bg' ).css( { 'display' : 'block' } );
        $('.menu' ).css( { 'left' : '-100%' } );
        $('.menu' ).animate( { left: '0px' }, { duration: giMenuDuration } );
    },

    hideMenu(){
        var giMenuDuration = 700;
        $('.menu' ).animate( { left: '-100%' }, { duration: giMenuDuration, complete:function(){ $('.menu_bg' ).css( { 'display' : 'none' } ); } } );
    },

  },
  mounted() {
  },
  watch: {
    'propscomCodeInfo':{
        immediate: true,
        deep: true,
        handler() {
        }
    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "public/css/main";

.type-main{
    height:60px;
}

.spacer {
  width: 80px;
}

.hdmenu {
    float: left;
    height: 50px;
    width: 700px;
    margin-left: 20px;
    line-height: 56px;
    font-size: 16px;
    padding-left: 50px;
    display: none;
}

ul {
    list-style:none;
    margin: 0;
    padding:0;
}

li {
    margin: 0 80px 0 0;
    padding: 0 0 0 0;
    border : 0;
    float: left;
    font-size: 14px;
    color: #fff;
}

a{
    color: #d9ebff
}
a:hover {
    color: #fff
}

.menu_bg {
    opacity: 0.8;
    width: 100%;
    height: 2000px;
    position: fixed;
    top:0px;
    left:0px;
    overflow: hidden;
    display: none;
    z-index: 10
}
.menu {
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height: 100%;
    background-color:#000;
}

.closearea {
    width:100%;
    text-align: right;
    cursor: pointer;
}

.menu-s {
    width:100%;
    text-align: center;
    opacity: 1;
    font-size: 30px;
}

.menu img {
    width:60px;
    opacity: 1;
}

.lowmenu {
    position: absolute;
    margin:22px 0 0 0;
    width:30px;
    display: inline;
    cursor: pointer;
    right:30px;
    text-align: right;
}

@media (min-width: 1000px) {
    .hdmenu {
        display: inline;
    }
    .lowmenu {
        display: none;
    }
}

.menu > div {
    padding: 2%;
}

</style>
